import { render, staticRenderFns } from "./MobileBar.vue?vue&type=template&id=8bdd2c64&"
import script from "./MobileBar.vue?vue&type=script&lang=js&"
export * from "./MobileBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../aristotle-website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports